module.exports = __webpack_public_path__ + "static/media/gallery.cdc886bc.jpg";